// extracted by mini-css-extract-plugin
export var content = "richText-module--content--soQpd";
export var copyWrap = "richText-module--copyWrap--mejec";
export var header = "richText-module--header--hJ3CD";
export var one_trust_overrides = "richText-module--one_trust_overrides--vYAD+";
export var page404Title = "richText-module--page404-title--Ra9v7";
export var simpleColouredCopyBlock = "richText-module--simpleColouredCopyBlock--TnYef";
export var textBlock = "richText-module--textBlock--n+6bL";